import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { searchFilterSelector } from '@cbridge-modules/search-filter';
import { UserAction } from '@cbridge-packages/user';
import { UserListAction } from '../userList.action';

type IState =
  & IGetSelectorStateType<typeof searchFilterSelector>;

export const reloadClientUserListEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOf(
    UserListAction.reload,
    UserAction.createDone,
  ),
  withLatestFrom(state$),
  mergeMap(([, state]) => {
    const search = searchFilterSelector(state);

    return [
      UserListAction.loadClient({ search }),
    ];
  }),
);
